import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { getListCompanies } from "../apiDefault/companies-api";

const LogoBar = styled.div`
  display: flex;
  flex-direction: row;
  width: 99.9%;
  overflow: scroll;
  height: 150px;
`;

const Logo = styled.img`
    align-self: center;
    max-height: 50%;
    width: 200px;
    margin-right: 40px;
}`;

export default function LogoBarComponent() {
  const [content, setContent] = useState([]);

  const getCompanies = async () => {
    const companies = await getListCompanies();
    setContent(companies);
  };
  const logoEl = useRef();

  const scrollInfinite = (el) => {
    return window.setInterval(() => {
      if (el.scrollLeft + el.offsetWidth < el.scrollWidth) {
        el.scrollLeft += 1;
      } else {
        el.scrollLeft = 0;
      }
    }, 10);
  };

  useEffect(() => {
    getCompanies();
  }, []);

  useEffect(() => {
    if (content.length === 0) {
      let timerId = null;
      if (logoEl.current) {
        timerId = scrollInfinite(logoEl.current);
      }
      return function cleanUp() {
        window.clearInterval(timerId);
      };
    }
  }, [content]);

  return (
    <LogoBar ref={logoEl} className="logobar">
      {content.map((company, index) => {
        if (
          company.logo &&
          (company.companyMember || company.companyMember == null)
        ) {
          return (
            <Logo
              key={"logo-company-" + index}
              src={process.env.REACT_APP_API_URL + "" + company.logo.url}
              alt={"logo " + company.name}
            />
          );
        } else {
          return null;
        }
      })}
    </LogoBar>
  );
}
